<script>
import { mapState, mapActions } from 'vuex';

export default {
  template: '#comment-new',
  data() {
    return {
      newCommentOpen: true,
      newCommentPhase: 0
    };
  },
  created() {
    this.newCommentPhase = this.general.comment.phase;
    this.$store.dispatch('general/setNewCommentPhase', 1);
  },
  methods: {
    openForm() {
      this.newCommentOpen = true;
      this.$store.dispatch('general/setNewCommentPhase', 1);
    },
    closeForm() {
      this.newCommentOpen = false;
      this.$store.dispatch('general/setNewCommentPhase', null);
    }
  },
  computed: {
    ...mapState(['general']),
    ...mapActions(['general/setNewCommentPhase'])
  }
};
</script>
